import { Phone, Mail, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useContent } from "../context/ContentContext";
import Logo from "./Logo";

export default function Footer() {
  const { t, pick } = useLang();
  const { content } = useContent();
  const c = content?.contact || {};
  const phone = c.phone || "540-314-1957";
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-obsidian px-5 md:px-10 pt-16 pb-8" data-testid="footer">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          <div>
            <Logo size={70} />
            <p className="mt-5 text-silver text-sm max-w-xs leading-relaxed">
              {pick(content?.hero, "subtitle")}
            </p>
          </div>
          <div className="md:justify-self-center">
            <h4 className="font-mono text-xs uppercase tracking-widest text-acid mb-5">{t("nav_contact")}</h4>
            <div className="space-y-3">
              <a href={`tel:${phone.replace(/[^0-9]/g, "")}`} className="flex items-center gap-3 text-white hover:text-acid transition-colors">
                <Phone size={16} /> {phone}
              </a>
              {c.email && (
                <a href={`mailto:${c.email}`} className="flex items-center gap-3 text-white hover:text-acid transition-colors">
                  <Mail size={16} /> {c.email}
                </a>
              )}
              <p className="text-silver text-sm">{pick(c, "area")}</p>
            </div>
          </div>
          <div className="md:justify-self-end">
            <h4 className="font-mono text-xs uppercase tracking-widest text-acid mb-5">Social</h4>
            <div className="flex gap-3">
              {c.facebook && (
                <a href={c.facebook} target="_blank" rel="noreferrer" className="border border-white/15 p-3 text-white hover:border-acid hover:text-acid transition-colors">
                  <Facebook size={18} />
                </a>
              )}
              {c.instagram && (
                <a href={c.instagram} target="_blank" rel="noreferrer" className="border border-white/15 p-3 text-white hover:border-acid hover:text-acid transition-colors">
                  <Instagram size={18} />
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-silver text-xs font-mono">
          <p>© {year} Zurita's Tree Services & Landscaping. {t("rights")}</p>
          <Link to="/admin" className="hover:text-acid transition-colors uppercase tracking-widest" data-testid="footer-admin-link">
            {t("admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
